import { makeSelectors } from '@utils/css';

const button = "dibbwnmzdo";
const chevron = "dibc1ya59p7";
const arrowButtonSelectors = makeSelectors({
  button,
  chevron
});

export { arrowButtonSelectors, button, chevron };
import "./arrow.style.linaria.module.css";
//# sourceMappingURL=arrow.style.js.map
